import dynamic from "next/dynamic";
import { ErrorBoundary } from "../../utilities/rollbar/ErrorBoundary";

export const enum IWidgetTypes {
  EVENTS = "events",
  MERITCHAT_MODERATOR = "meritchat_moderator",
  CONTRIBUTING_ORGANIZATIONS = "contributing_organizations",
  SHOP = "shop",
  CONTACT = "contact",
  LEADERBOARD = "leaderboard",
  STAFF = "staff",
  OUTREACH_SUITE = "outreach_suite",
  WEBSITE = "website",
  BOARD_BLOCS = "board_blocks",
}

const widgetTypes = {
  [IWidgetTypes.SHOP]: dynamic(() => import("./ShopWidget")),
  [IWidgetTypes.CONTACT]: dynamic(() => import("./SchoolFeedContactCard")),
  [IWidgetTypes.CONTRIBUTING_ORGANIZATIONS]: dynamic(
    () => import("./ContributingOrganizationsWidget"),
  ),
  [IWidgetTypes.LEADERBOARD]: dynamic(() => import("./LeaderboardWidget")),
  [IWidgetTypes.MERITCHAT_MODERATOR]: dynamic(
    () => import("./MeritChatModeratorWidget"),
  ),
};

export const Widget = (props) => {
  const { widget, ...forwardedProps } = props;
  const WidgetTypeComponent = widgetTypes[widget.type] || null;

  return (
    <ErrorBoundary>
      <WidgetTypeComponent {...forwardedProps} />
    </ErrorBoundary>
  );
};
